import ButtonBase from '@mui/material/ButtonBase';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { styled } from '@mui/material/styles';
import EllipsisTypography from '../EllipsisTypography/EllipsisTypography';
import NRArrowForwardIcon from '../../NRIcons/NRArrowForwardIcon';
import { textAlign } from '@mui/system';

const MetricAltAvatar = styled(props => <Avatar {...props} />)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  color: theme.palette.text.iconInfo,
  width: theme.spacing(6),
  height: theme.spacing(6)
}));

function NRMetricCard({ metric, result, caption, icon, rightIcon, onCardClick, maxWidth, minWidth, flexGrow = 1 }) {
  const theme = useTheme();
  return (
    <Box
      {...(!!onCardClick && { onClick: onCardClick, component: ButtonBase })}
      sx={{
        flexGrow,
        flexShrink: 1,
        flexBasis: 0,
        minHeight: 152,
        cursor: 'default',
        p: 2,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: theme.shape.borderRadius,
        ...(!!maxWidth && { maxWidth }),
        ...(!!minWidth && { minWidth }),
        ...(!!onCardClick && {
          cursor: 'pointer',
          '&:hover': {
            bgcolor: theme.palette.action.hover,
            borderColor: theme.palette.text.border
          },
          '&:active': {
            bgcolor: theme.palette.action.selected
          }
        })
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <MetricAltAvatar>{icon}</MetricAltAvatar>
        <Box>{rightIcon}</Box>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '100%', overflow: 'clip' }}>
        <Typography variant="label" color="text.secondary" children={metric} />
        <EllipsisTypography
          variant="h3"
          sx={{
            whiteSpace: 'nowrap',
            maxWidth: '100%',
            textAlign: 'start'
          }}
          children={result}
        />
        <Box gap={1} sx={{ display: 'flex', width: '100%' }}>
          <EllipsisTypography
            sx={{
              textAlign: 'start',
              minHeight: theme.spacing(2),
              textDecoration: !!onCardClick ? 'underline' : 'unset',
              whiteSpace: 'nowrap',
              maxWidth: '92%'
            }}
            variant="caption"
            color="text.secondary"
            children={caption}
          />
          {!!onCardClick && !!caption && <NRArrowForwardIcon width={theme.spacing(2)} height={theme.spacing(2)} color={theme.palette.text.icon} />}
        </Box>
      </Box>
    </Box>
  );
}
export default NRMetricCard;
